import { type DatasetRow } from '@blaze-shared/schema-domain';

/** Whatever the previous node emitted: one row, a list of rows, or nothing at all. */
export type NodeInput = DatasetRow | DatasetRow[] | null | undefined;

/**
 * Reads a node's input as rows.
 *
 * Almost every action iterates rows, whereas input arrives in all three shapes. Nullish input
 * reads as no rows; a single row reads as a list of one.
 */
export function normalizeNodeInput(nodeInput: NodeInput): DatasetRow[] {
  if (nodeInput === null || nodeInput === undefined) {
    return [];
  }
  return Array.isArray(nodeInput) ? nodeInput : [nodeInput];
}
